import { memo } from 'react'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'

import * as Styled from './styled'

const AiAvatarTitle: React.FC = () => {
  return (
    <Styled.Title type="h1" color="secondaryDark">
      {translate(T.AI_AVATAR_LABEL)}
    </Styled.Title>
  )
}

export default memo(AiAvatarTitle)
